<template>
  <v-container fluid class="portfolio-page">
    <v-row no-gutters class="d-flex align-center mt-10 mb-4">
      <v-btn icon class="mr-2" @click="$router.push('/portfolio')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="page-title mb-0">Add Portfolio</h1>
    </v-row>
    <v-row>
      <v-col lg="8" md="10" cols="12">
        <v-card class="mx-1 mb-1">
          <v-card-title class="pa-6 pb-3">
            <p>Details</p>
          </v-card-title>
          <v-card-text class="pa-6 pt-0">
            <v-form ref="portfolioForm" @submit.prevent="save()">
              <v-text-field
                v-model="form.name"
                label="Name"
                hint="e.g Retoria, Decima"
                outlined
                dense
                required
                :error-messages="formErrors.name"
              ></v-text-field>

              <v-select
                @change="onCategoryChange"
                return-object
                :items="categories"
                item-text="name"
                item-value="id"
                label="Category"
                outlined
                dense
                required
                :loading="isCategoriesLoading"
                :error-messages="formErrors.category_id"
              ></v-select>

              <v-file-input
                v-model="form.image"
                show-size
                :rules="rules"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Pick an image"
                prepend-icon="mdi-camera"
                label="Image"
                outlined
                dense
                required
                :error-messages="formErrors.image"
              ></v-file-input>

              <v-text-field
                v-if="showUrlField"
                v-model="form.url"
                label="URL"
                placeholder="https://"
                outlined
                dense
                :required="showUrlField"
                :error-messages="formErrors.url"
              ></v-text-field>

              <div class="d-flex mt-2">
                <v-btn
                  type="submit"
                  :loading="isLoading"
                  :disabled="form.busy"
                  color="primary"
                  class="mr-3 text-capitalize"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Save
                </v-btn>
                <v-btn
                  text
                  class="text-capitalize"
                  @click="$router.push('/portfolio')"
                >
                  Cancel
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Form from "vform";
import { objectToFormData } from "object-to-formdata";

export default {
  name: "AddPortfolio",
  data() {
    return {
      isLoading: false,
      isCategoriesLoading: true,
      categories: [],
      showUrlField: false,
      form: new Form({
        name: "",
        category_id: "",
        image: [],
        url: "",
      }),
      formErrors: {
        name: [],
        category_id: [],
        image: [],
        url: [],
      },
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Image size should be less than 2 MB!",
      ],
    };
  },
  methods: {
    getCategories() {
      this.isCategoriesLoading = true;
      axios.get("portfolio-categories")
        .then((response) => {
          this.categories = response.data;
        })
        .catch(() => {
          this.$toast.error("Failed to load categories");
        })
        .finally(() => {
          this.isCategoriesLoading = false;
        });
    },
    save() {
      this.isLoading = true;
      this.formErrors = { name: [], category_id: [], image: [], url: [] };

      this.form
        .submit("post", "portfolios", {
          transformRequest: [
            function(data) {
              return objectToFormData(data);
            },
          ],
        })
        .then(() => {
          this.isLoading = false;
          this.$toast.success("Portfolio item added successfully");
          this.$router.push({ name: "portfolio" });
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            if (errors.name) this.formErrors.name = errors.name;
            if (errors.category_id) this.formErrors.category_id = errors.category_id;
            if (errors.image) this.formErrors.image = errors.image;
            if (errors.url) this.formErrors.url = errors.url;
          } else {
            this.$toast.error("Failed to save portfolio item");
          }
        });
    },
    onCategoryChange(category) {
      this.form.category_id = category.id;
      this.showUrlField = category.type === 2 || category.type === 3;
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>

<style src="./AddPortfolio.scss" scoped lang="scss"></style>
